import React from "react";
import classes from "./FancyToggle.module.css";

const FancyToggle = (props) => {
    return (
        <div className={classes['toggle-container-container']}
        style = {{
            '--active-color' : (props.active_colour ? props.active_colour : 'var(--main-color)'),
            '--inactive-color' : (props.inactive_colour ? props.inactive_colour :  'var(--legacy-curtailed)')
        }}
        >
            
            <div className={classes['toggle-container']}>
                <input className={classes['toggle-input']} type="checkbox" onChange = {props.handleChange} checked = {props.state} />
                <svg className={classes.toggle} viewBox="0 0 292 142" xmlns="http://www.w3.org/2000/svg">
                    <path className={classes['toggle-background']} d="M71 142C31.7878 142 0 110.212 0 71C0 31.7878 31.7878 0 71 0C110.212 0 119 30 146 30C173 30 182 0 221 0C260 0 292 31.7878 292 71C292 110.212 260.212 142 221 142C181.788 142 173 112 146 112C119 112 110.212 142 71 142Z" />
                    <rect className={`${classes['toggle-icon']} ${classes.on}`} x="64" y="39" width="12" height="64" rx="6" />
                    <path className={`${classes['toggle-icon']} ${classes.off}`} fillRule="evenodd" d="M221 91C232.046 91 241 82.0457 241 71C241 59.9543 232.046 51 221 51C209.954 51 201 59.9543 201 71C201 82.0457 209.954 91 221 91ZM221 103C238.673 103 253 88.6731 253 71C253 53.3269 238.673 39 221 39C203.327 39 189 53.3269 189 71C189 88.6731 203.327 103 221 103Z" />
                    <g filter="url('#goo')">
                        <rect className={classes['toggle-circle-center']} x="13" y="42" width="116" height="58" rx="29" fill="#fff" />
                        <rect className={`${classes['toggle-circle']} ${classes.left}`} x="14" y="14" width="114" height="114" rx="58" fill="#fff" />
                        <rect className={`${classes['toggle-circle']} ${classes.right}`} x="164" y="14" width="114" height="114" rx="58" fill="#fff" />
                    </g>
                    <filter id="goo">
                        <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
                    </filter>
                </svg>
            </div>
        </div>
    );
};

export default FancyToggle;